package com.evoapps.evoshift.domain.usecase.availability

import com.evoapps.evoshift.domain.model.WeeklyAvailabilityTemplate
import com.evoapps.evoshift.domain.repository.AvailabilityRepository

class SaveWeeklyAvailabilityTemplateUseCase(
    private val availabilityRepository: AvailabilityRepository
) {
    suspend operator fun invoke(template: WeeklyAvailabilityTemplate): Result<Unit> {
        return availabilityRepository.saveWeeklyAvailabilityTemplate(template)
    }
}
